<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import { isValidColor } from '@/support/utils/validHexColor'

export default {
  name: 'ThematicPagesColors',
  components: {
    FormSection: () => import('@/components/general/FormSection'),
    ColorInputField: () => import('@/components/general/ColorInputField')
  },

  props: {
    alias: {
      type: String,
      default: ''
    },

    colorHeader: {
      type: String,
      default: ''
    },

    colorBottom: {
      type: String,
      default: ''
    },

    colorMenu: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      valueColorHeader: this.colorHeader || '',
      valueColorBottom: this.colorBottom || '',
      valueColorMenu: this.colorMenu || ''
    }
  },

  validations () {
    return {
      valueColorHeader: {
        required: requiredIf(() => {
          const result = (this.alias || '').toLowerCase().trim() !== 'corporative'

          return result
        }),

        hexColorValidate: (val) => {
          if (!val) return true

          return isValidColor(val)
        }
      },

      valueColorBottom: {
        required,
        hexColorValidate: (val) => {
          return isValidColor(val)
        }
      },

      valueColorMenu: {
        hexColorValidate: (val) => {
          if (!val) return true

          return isValidColor(val)
        }
      }
    }
  },

  computed: {
    isCorporative () {
      return (this.alias || '').toLowerCase().trim() === 'corporative'
    }
  },

  watch: {
    colorHeader (val) {
      this.valueColorHeader = val || ''
    },

    colorBottom (val) {
      this.valueColorBottom = val || ''
    },

    colorMenu (val) {
      this.valueColorMenu = val || ''
    },

    alias () {
      if (this.$v && this.$v.valueColorHeader) {
        this.$nextTick(() => {
          this.$v.valueColorHeader.$reset()
          this.$v.valueColorHeader.$touch()
        })
      }
    }
  },

  methods: {
    onInputHeader (v) {
      this.valueColorHeader = v
      this.$emit('update:colorHeader', v)
    },

    onInputBottom (v) {
      this.valueColorBottom = v
      this.$emit('update:colorBottom', v)
    },

    onInputMenu (v) {
      this.valueColorMenu = v
      this.$emit('update:colorMenu', v)
    }
  }
}
</script>

<template>
  <div class="thematic-pages-colors">
    <FormSection
      v-if="isCorporative"
      :title="$t('global:thematicPages.menu.color')"
    >
      <div class="hex-under-description">
        <label class="form-input-subtext">{{
          $t('global:thematicPages.menu.color.under-description')
        }}</label>
      </div>

      <ColorInputField
        :value="valueColorMenu"
        :label="$t('global:thematicPages.menu.color.placeholder')"
        :validation="$v.valueColorMenu"
        @input="onInputMenu"
      />
    </FormSection>

    <FormSection :title="$t('global:thematicPages.background.colors')">
      <div class="hex-under-description">
        <label class="form-input-subtext">{{
          $t('global:thematicPages.background.colors.under-description')
        }}</label>
      </div>

      <ColorInputField
        :key="`colorheader-${alias}`"
        :value="valueColorHeader"
        :label="$t('global:thematicPages.background.color.1')"
        :validation="$v.valueColorHeader"
        @input="onInputHeader"
      />

      <ColorInputField
        :value="valueColorBottom"
        :label="$t('global:thematicPages.background.color.2')"
        :validation="$v.valueColorBottom"
        @input="onInputBottom"
      />
    </FormSection>
  </div>
</template>

<style scoped>
.thematic-pages-colors .hex-under-description {
  margin-bottom: 10px;
}
</style>
<!--
  end component
-->
